import { h, Component, createRef } from 'preact';
import { navigateInternally } from 'utils/bolt/index';
import { getDonationTotal } from 'components/utils/donationsAPI';
import Store from 'store/store';
import Button from 'components/bolt/button/button.js';
import s from 'components/bolt/donations/donations.sss';
import { animate, utils } from 'animejs';
export default class DonationTicker extends Component {
    pollTimeout;
    state;
    amountRef = createRef();
    wrapRef = createRef();
    observer = null;
    animation = null;
    constructor(props) {
        super(props);
        this.state = {
            donationAmount: 0,
            visible: false,
        };
        this.pollTimeout = null;
    }
    componentDidMount() {
        this.fetchDonationAmount();
        this.pollTimeout = setInterval(() => {
            this.fetchDonationAmount();
        }, 1000 * 10); // Poll every 60 seconds
        this.createAnimation();
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && !this.state.visible) {
                    this.setState({ visible: true });
                    this.animate(true);
                }
                else if (entry.boundingClientRect.top > 0) {
                    this.setState({ visible: false });
                    this.animate(false);
                }
            });
        }, { threshold: 0.001, rootMargin: '0% 0% -30% 0%' });
        this.observer.observe(this.wrapRef.current);
    }
    createAnimation() {
        const elems = this.wrapRef.current.querySelectorAll(`.${s.container}, .${s.title}, .${s.amount}, .${s.donateButton}`);
        this.animation = animate(elems, {
            opacity: [0, 1],
            translateY: [10, 0],
            duration: 300,
            delay: utils.stagger(100),
        });
        this.animation.pause();
    }
    animate(animateIn) {
        this.animation?.cancel();
        if (animateIn) {
            this.animation.play();
        }
        else {
            this.animation.reverse();
        }
    }
    componentWillUnmount() {
        this.observer?.disconnect();
        if (this.pollTimeout) {
            clearInterval(this.pollTimeout);
        }
    }
    fetchDonationAmount() {
        getDonationTotal().then((total) => {
            if (total) {
                animate(this.amountRef.current, {
                    innerHTML: [this.state.donationAmount, total],
                    duration: 1000,
                    easing: 'easeInOutQuad',
                    modifier: (value) => {
                        return Math.round(value).toLocaleString();
                    },
                });
                this.setState({ donationAmount: total });
            }
        });
    }
    render() {
        const { copy } = this.props?.appData || {};
        const { donationAmount } = this.state;
        return (h("div", { class: s.wrap, ref: this.wrapRef },
            h("div", { class: s.container },
                h("h2", { class: s.title }, copy?.siteCopy?.homeDonationTickerTitle),
                h("p", { class: s.amount },
                    "$",
                    h("span", { ref: this.amountRef }, donationAmount.toLocaleString())),
                h(Button, { class: s.donateButton, trigger: () => {
                        Store.emit('TRACK_HOME_DONATION_BUTTON_CLICK');
                        // TODO: Get this variable from app data instead of hard code
                        navigateInternally('give');
                    } }, copy.siteCopy.homeButtonDonate))));
    }
}
